import React from 'react';

type Props = {
  className?: string;
};

const Chevron: React.FC<Props> = ({ className }) => {
  return (
    <span className={className}>
      <svg
        width="16"
        height="21"
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 4536">
          <path
            id="Vector 1"
            d="M2 1.94131L12 10.5751L2 19.209"
            stroke="currentColor"
            strokeWidth="4"
          />
        </g>
      </svg>
    </span>
  );
};

export default Chevron;
